import React from "react";
import SEO from "../components/SEO";
import Hero from '../components/Hero';
// import IntroSection from '../components/IntroSection';
// import ContentSection from '../components/ContentSection';
// import LatestUpdateHome from "../components/LatestUpdateHome";
import AboutHome from "../components/AboutHome";
// import OurFounder from "../components/OurFounder";
// import AboutUs from "../components/AboutUs";
// import RedesignedSection from "../components/RedesignedSection";
// import OurPeopleV1 from "../components/OurPeopleV1";
import OurPeopleV2 from "../components/OurPeopleV2";
import WhatWeDoHome from "../components/WhatWeDoHome";
// import SeekSuccess from "../components/SeekSuccess";
// import GrowthOpportunity from "../components/GrowthOpportunity";
// import WhyChooseUs from "../components/WhyChooseUs";
// import ConclusionHome from "../components/ConclusionHome";
import ServiceHighlightHome from "../components/ServiceHighlightHome";

// import GetInTouch from "../components/GetInTouch";
import GetInTouchV2 from "../components/GetInTouchV2";


const Home = () => {
  return (
    <>
      {/* =================== SEO Meta Tags =================== */}
      <SEO
        title="Global PR, Marketing & AI Technology Solutions"
        description="8 Insights delivers PR, marketing, communications, and AI-driven technology solutions that help brands grow across Asia Pacific and global markets."
        url="https://8-insights.com/"
        image="https://8-insights.com/home.jpeg"
        imageAlt="8 Insights — Global PR, Marketing and AI Technology Solutions"
        locale="en_HK"
        language="en"
        robots="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
        bingbot="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
        googlebotNews="index,follow"
        googleExtended="index"
        author="8 Insights"
        publisher="8 Insights"
        creator="8 Insights"
        applicationName="8 Insights"
        themeColor="#091362"
        referrer="strict-origin-when-cross-origin"
        formatDetection="telephone=no"
        keywords={[
          "PR agency Hong Kong",
          "global PR agency",
          "marketing communications agency",
          "digital PR services",
          "brand communications",
          "AI technology solutions",
          "marketing consultancy",
          "corporate communications",
          "strategic communications",
          "reputation management",
          "integrated marketing agency",
          "Asia Pacific PR agency",
          "AI-powered marketing solutions",
          "technology consulting",
          "global brand strategy",
        ]}
        jsonLd={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Organization",
              "@id": "https://8-insights.com/#organization",
              "name": "8 Insights",
              "url": "https://8-insights.com/",
              "logo": {
                "@type": "ImageObject",
                "url": "https://8-insights.com/logo512.png",
              },
              "description": "8 Insights delivers PR, marketing, communications, and AI-driven technology solutions that help brands grow across Asia Pacific and global markets.",
              "areaServed": ["Hong Kong","Singapore","India","United States","Asia Pacific","Global"],
              "knowsAbout": [
                "Public Relations","Marketing","Communications","Brand Strategy",
                "Digital PR","Corporate Communications","AI Technology Solutions",
                "Technology Consulting","Web Development","Mobile App Development","SEO","AIO",
              ],
              "sameAs": ["https://www.linkedin.com/company/8-insights"],
              "location": [
                {
                  "@type": "Place",
                  "name": "8 Insights Hong Kong Office",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Level 20, One International Finance Centre, Harbour View Street",
                    "addressLocality": "Central",
                    "addressRegion": "Hong Kong",
                    "addressCountry": "HK",
                  },
                },
                {
                  "@type": "Place",
                  "name": "8 Insights USA Office",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "3101 Ocean Park Blvd Ste 100",
                    "addressLocality": "Santa Monica",
                    "addressRegion": "CA",
                    "postalCode": "90405",
                    "addressCountry": "US",
                  },
                },
                {
                  "@type": "Place",
                  "name": "8 Insights New Delhi Office",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "5/F Caddie Commercial Tower, Aerocity",
                    "addressLocality": "New Delhi",
                    "addressRegion": "Delhi",
                    "postalCode": "110037",
                    "addressCountry": "IN",
                  },
                },
                {
                  "@type": "Place",
                  "name": "8 Insights Gurugram Office",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "N-14/4, Block N, DLF Phase-2, Sector 25",
                    "addressLocality": "Gurugram",
                    "addressRegion": "Haryana",
                    "postalCode": "122002",
                    "addressCountry": "IN",
                  },
                },
                {
                  "@type": "Place",
                  "name": "8 Insights Singapore Office",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "68 Circular Road, #02-01",
                    "postalCode": "049422",
                    "addressCountry": "SG",
                  },
                },
              ],
            },
            {
              "@type": "WebSite",
              "@id": "https://8-insights.com/#website",
              "url": "https://8-insights.com/",
              "name": "8 Insights",
              "publisher": { "@id": "https://8-insights.com/#organization" },
              "inLanguage": "en-HK",
            },
            {
              "@type": "WebPage",
              "@id": "https://8-insights.com/#webpage",
              "url": "https://8-insights.com/",
              "name": "Global PR, Marketing & AI Technology Solutions | 8 Insights", // full title in schema is correct
              "description": "8 Insights delivers PR, marketing, communications, and AI-driven technology solutions that help brands grow across Asia Pacific and global markets.",
              "isPartOf": { "@id": "https://8-insights.com/#website" },
              "about": { "@id": "https://8-insights.com/#organization" },
              "primaryImageOfPage": {
                "@type": "ImageObject",
                "url": "https://8-insights.com/home.jpeg",
              },
              "inLanguage": "en-HK",
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://8-insights.com/#breadcrumb",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://8-insights.com/" },
              ],
            },
            {
              "@type": "FAQPage",
              "@id": "https://8-insights.com/#faq",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "What services does 8 Insights provide?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "8 Insights provides PR, marketing communications, brand strategy, digital PR, corporate communications, AI technology solutions, web development, mobile app development, SEO, AIO, and technology consulting services.",
                  },
                },
                {
                  "@type": "Question",
                  "name": "Which regions does 8 Insights serve?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "8 Insights serves businesses across Hong Kong, Singapore, India, the United States, Asia Pacific, and global markets.",
                  },
                },
                {
                  "@type": "Question",
                  "name": "How does 8 Insights combine PR, marketing, and AI technology?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "8 Insights combines strategic communications, brand storytelling, digital marketing, automation, AI-driven technologies, and custom digital platforms to help brands improve visibility, engagement, efficiency, and business growth.",
                  },
                },
                {
                  "@type": "Question",
                  "name": "Does 8 Insights provide digital PR and brand communication services?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes. 8 Insights provides digital PR, brand communications, corporate communications, marketing consultancy, reputation management, and integrated communication strategies for businesses and organizations.",
                  },
                },
                {
                  "@type": "Question",
                  "name": "Does 8 Insights offer custom AI and technology solutions?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes. 8 Insights develops tailored AI and technology solutions including websites, mobile applications, automation workflows, AI integrations, digital platforms, and business technology systems based on client requirements.",
                  },
                },
              ],
            },
          ],
        }}
      />

      {/* =================== Page UI =================== */}
      <div>
        <section className="hero-section">
          <Hero />
        </section>

        {/* <LatestUpdateHome /> */}

        {/* <RedesignedSection />
        <AboutUs /> */}

        <AboutHome />

        {/* <OurPeopleV1 /> */}
        <OurPeopleV2 />
        <WhatWeDoHome />
        <ServiceHighlightHome />

        {/* <SeekSuccess /> */}
        {/* <GrowthOpportunity /> */}
        {/* <WhyChooseUs /> */}
        {/* <ConclusionHome /> */}

        {/* <GetInTouch /> */}

        <GetInTouchV2 />

        {/* <OurFounder /> */}

        {/* <IntroSection /> */}
        {/* <ContentSection /> */}
      </div>
    </>
  );
};

export default Home;
